
import React from 'react';
import { motion } from 'framer-motion';

const serviceAreas = [
  { name: 'Sant Andreu', type: 'Sede central' },
  { name: 'Eixample', type: 'Barrio' },
  { name: 'Gràcia', type: 'Barrio' },
  { name: 'Sants-Montjuïc', type: 'Barrio' },
  { name: 'Les Corts', type: 'Barrio' },
  { name: 'Sarrià-Sant Gervasi', type: 'Barrio' },
  { name: 'Sant Martí', type: 'Barrio' },
  { name: 'Ciutat Vella', type: 'Barrio' },
  { name: 'Horta-Guinardó', type: 'Barrio' },
  { name: 'Nou Barris', type: 'Barrio' },
  { name: "L'Hospitalet", type: 'Municipio' },
  { name: 'Badalona', type: 'Municipio' },
  { name: 'Santa Coloma', type: 'Municipio' },
  { name: 'Cornellà', type: 'Municipio' },
  { name: 'Sant Cugat', type: 'Municipio' },
  { name: 'Esplugues', type: 'Municipio' },
];

const ServiceAreasSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0A1B3D] to-[#0B5FFF] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-12"
        >
          <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium mb-4">
            <i className="ri-map-pin-line"></i>
            Cobertura en toda el área metropolitana
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 px-4">
            Zonas de servicio en Barcelona
          </h2>
          <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto px-4">
            Desde nuestra sede en Sant Andreu, ofrecemos <a href="https://pladures.es/barcelona/" target="_blank" rel="noopener noreferrer" className="text-white underline hover:text-[#4DA3FF] transition-colors">instalación de pladur profesional en todos los barrios de Barcelona</a> y municipios del área metropolitana.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
          {serviceAreas.map((area, index) => (
            <motion.div
              key={area.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className={`relative group cursor-pointer ${
                area.type === 'Sede central'
                  ? 'bg-[#0B5FFF] ring-2 ring-white/50'
                  : 'bg-white/10 backdrop-blur-sm hover:bg-white/20'
              } rounded-xl p-3 sm:p-5 transition-all duration-300`}
            >
              <div className="flex items-start gap-2 sm:gap-3">
                <div
                  className={`w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${
                    area.type === 'Sede central'
                      ? 'bg-white/20'
                      : area.type === 'Municipio'
                      ? 'bg-[#4DA3FF]/30'
                      : 'bg-white/10'
                  }`}
                >
                  <i
                    className={`${
                      area.type === 'Sede central'
                        ? 'ri-home-office-line'
                        : area.type === 'Municipio'
                        ? 'ri-building-2-line'
                        : 'ri-community-line'
                    } text-lg sm:text-xl text-white`}
                  ></i>
                </div>
                <div className="min-w-0 flex-1">
                  <span className="font-semibold text-white text-sm sm:text-base leading-tight block break-words">
                    {area.name}
                  </span>
                  <span
                    className={`text-xs ${
                      area.type === 'Sede central'
                        ? 'text-white/90 font-medium'
                        : 'text-white/60'
                    }`}
                  >
                    {area.type}
                  </span>
                </div>
              </div>
              {area.type === 'Sede central' && (
                <div className="absolute -top-2 -right-2 w-5 h-5 sm:w-6 sm:h-6 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-star-fill text-[#0B5FFF] text-xs sm:text-sm"></i>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-8 sm:mt-12 text-center px-4"
        >
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-4 bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-6 max-w-full">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-truck-line text-xl sm:text-2xl text-white"></i>
              </div>
              <div className="text-left">
                <p className="text-white font-semibold text-sm sm:text-base">¿Tu zona no aparece?</p>
                <p className="text-white/70 text-xs sm:text-sm">Consúltanos, cubrimos más áreas</p>
              </div>
            </div>
            <a
              href="tel:+34629501941"
              className="whitespace-nowrap bg-white text-[#0A1B3D] px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold text-sm sm:text-base hover:bg-[#4DA3FF] hover:text-white transition-all duration-300 flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Llamar ahora
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
